import { AppStoreButtons } from './AppStoreButtons'

const pillars = [
  {
    icon: 'adaptive_audio_mic',
    title: 'Train around real life',
    body: 'Short lunch break, packed gym, low energy: adjust the plan without skipping the session.',
  },
  {
    icon: 'psychology_alt',
    title: 'Reduce decision fatigue',
    body: 'Know what to do next before you arrive, then keep moving once the workout starts.',
  },
  {
    icon: 'ads_click',
    title: 'Keep progress visible',
    body: 'Track what you did, compare recent work, and build consistency one session at a time.',
  },
]

export function ConsistencySection() {
  return (
    <section className="section-y section-x text-center max-w-5xl mx-auto">
      <h2 className="font-headline font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-4 tracking-tight px-2">
        Consistency beats the perfect plan
      </h2>
      <div className="w-24 h-1 bg-secondary mx-auto mb-10 sm:mb-16" />

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10 md:gap-12">
        {pillars.map((p) => (
          <div key={p.title} className="space-y-4 px-2">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-surface-container-high">
              <span className="material-symbols-outlined text-primary">{p.icon}</span>
            </div>
            <h4 className="font-headline font-bold text-lg sm:text-xl">{p.title}</h4>
            <p className="text-on-surface-variant text-sm leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-14 sm:mt-20 flex flex-col items-center gap-5 sm:gap-6 px-2">
        <p className="text-on-surface-variant text-base sm:text-lg">
          Coming soon on iOS and Android.
        </p>
        <AppStoreButtons centered />
      </div>
    </section>
  )
}
